var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"group-toggle-button",class:{
    active: _vm.expanded,
    'is-disabled': _vm.disabled,
  },attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title,"aria-disabled":_vm.disabled ? 'true' : 'false'},on:{"click":_vm.toggle}},[_c('i',{class:_vm.iconClass}),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }